import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { ManagementComponentBase, ColumnProperty } from '../_shared/base.management.component';
import { SelfieCamService, SelfieCamFormData, SelfieCamListView } from '../_services/selfie-cam.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';

@Component({
  templateUrl: '../_shared/base.management.component.html',
  styleUrls: ['../_shared/base.management.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelfieCamManagementComponent extends ManagementComponentBase<SelfieCamListView, SelfieCamFormData> {
  constructor(
    sefieCamService: SelfieCamService,
    router: Router,
    dialogService: DialogService,
    viewRef: ViewContainerRef,
    httpClient: HttpClient,
    userService: UserService,
    spinner: NgxSpinnerService,
    jwtTokenService: JWTTokenService
  ) {
    super(sefieCamService, router, dialogService, viewRef, httpClient, userService, spinner, jwtTokenService);

     const newColumn: ColumnProperty = { propertyName: 'photosCount', sortable: true, headerName: 'Shared Selfies', dataName: 'photosCount' };
     this.additionalColumns.push(newColumn);
  }

  protected GetRouteName(): string {
    return 'selfie-cam';
  }

}

